import React from 'react';

import { SvgIcon, SvgIconProps } from '@material-ui/core';

interface PlannedOutageIconProps extends Omit<SvgIconProps, 'color'> {
  size?: number;
  title?: string;
  shadow?: string;
}

const PlannedOutageIcon: React.FC<PlannedOutageIconProps> = ({
  size = 32,
  title = '',
  ...props
}) => {
  const shadow =
    props?.shadow ?? `drop-shadow(0px 0px ${size * 0.15}px rgba(0,0,0,0.5))`;
  const rx = 19;

  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
      style={{ filter: shadow }}
    >
      <g>
        {title && <title>{title}</title>}
        <rect x={0} y={0} width={size} height={size} rx={rx} fill={'#004680'} />
        <rect
          x={1}
          y={1}
          width={size - 2}
          height={size - 2}
          rx={rx - 1}
          strokeWidth={2}
          stroke={'white'}
          fill="none"
        />
        <g
          mask="url(#mask0_1011_11629)"
          style={{ transform: 'translate(-1px, -1px)' }}
        >
          <path
            d="M23.6375 25.9999L17.3625 19.7249L18.7875 18.2999L25.0625 24.5749L23.6375 25.9999ZM9.1125 25.9999L7.6875 24.5749L14.9375 17.3249L12.2625 14.6499L11.6875 15.2249L10.5875 14.1249V16.2499L9.9875 16.8499L6.9375 13.7999L7.5375 13.1999H9.6875L8.4875 11.9999L11.7625 8.7249C12.0458 8.4416 12.3541 8.2499 12.6875 8.1499C13.0208 8.0499 13.3875 7.9999 13.7875 7.9999C14.1875 7.9999 14.5541 8.0707 14.8875 8.2124C15.2208 8.3541 15.5291 8.5666 15.8125 8.8499L13.1375 11.5249L14.3375 12.7249L13.7375 13.3249L16.3375 15.9249L19.3875 12.8749C19.2541 12.6582 19.15 12.4082 19.075 12.1249C19 11.8416 18.9625 11.5416 18.9625 11.2249C18.9625 10.3416 19.2833 9.5791 19.925 8.9374C20.5666 8.2957 21.3291 7.9749 22.2125 7.9749C22.4625 7.9749 22.675 7.9999 22.85 8.0499C23.025 8.0999 23.1708 8.1666 23.2875 8.2499L21.1625 10.3749L23.0375 12.2499L25.1625 10.1249C25.2458 10.2582 25.3166 10.4207 25.375 10.6124C25.4333 10.8041 25.4625 11.0249 25.4625 11.2749C25.4625 12.1582 25.1416 12.9207 24.5 13.5624C23.8583 14.2041 23.0958 14.5249 22.2125 14.5249C21.9125 14.5249 21.6541 14.5041 21.4375 14.4624C21.2208 14.4207 21.0208 14.3582 20.8375 14.2749L9.1125 25.9999Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
};

export default PlannedOutageIcon;
